  <div class="main">
    <div class="header">
      {{'ORGANISATION.organisation' | translate}}
      <i class="material-icons" (click)="closeDialog();">clear</i>
    </div>
    <div class="section">
      <input class="form-input orgName" [(ngModel)]="organisation.name" [placeholder]="'ORGANISATION.orgName' | translate" type="text"/>
      <input type="text" id="placesSearch" [placeholder]="'ORGANISATION.address' | translate" class="form-input orgName" />
      <!-- <input class="form-input orgName" [(ngModel)]="organisation.email_id" [placeholder]="'ORGANISATION.email' | translate " type="text"/>
      <input class="form-input orgName" [(ngModel)]="organisation.mobile" [placeholder]="'ORGANISATION.mobile' | translate " type="text"/> -->
      <div class="submitButton">
        <div class="button" (click)="createOrganisation();">
          {{'ORGANISATION.submitButton' | translate}}
        </div>
      </div>
    </div>
  </div>
